import { getPermissionEntitlements, getFeatureEntitlements, getEntitlements } from '@frontegg/redux-store';
import { useAuth } from './hooks';

/**
 * @returns entitlemenets state as stored in the user
 */
const useEntitlementsState = () => useAuth(({
  user
}) => user == null ? void 0 : user.entitlements);

/**
  @param key
  @returns if the user is entitled to the given feature. Attaching the justification if not
*/
export const useFeatureEntitlements = key => {
  const entitlements = useEntitlementsState();
  return getFeatureEntitlements(entitlements, key);
};

/**
  @param key
  @returns if the user is entitled to the given permission. Attaching the justification if not
*/
export const usePermissionEntitlements = key => {
  const entitlements = useEntitlementsState();
  return getPermissionEntitlements(entitlements, key);
};

/**
  @param entitledToOptions including permission or feature key
  @returns if the user is entitled to the given feature or permission (check only one). Attaching the justification if not
*/
export const useEntitlements = options => {
  const entitlements = useEntitlementsState();
  return getEntitlements(entitlements, options);
};